import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data,
  })
}

export function logout(data) {
  return request({
    url: '/area/doEdit',
    method: 'post',
    data,
  })
}

export function getInfo(data) {
  return request({
    url: '/area/doEdit',
    method: 'post',
    data,
  })
}
